// extracted by mini-css-extract-plugin
export default {"wrapper":"I1","dropdownButton":"J1","carat":"K1","caratPointingDown":"L1","selectBox":"M1","dropdown":"N1","header":"O1","instructions":"P1","counter":"Q1","itemWrapper":"R1","flavorImg":"S1","left":"T1","quantityControl":"U1","quantity":"V1","qtyButton":"W1","minus":"X1","plus":"Y1"};
    if(module.hot) {
      // 1714422957985
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  